import React from "react";
import CourseCollectionNavigation from "../CourseCollectionNavigation/CourseCollectionNavigation";

export default class LocationsUsed extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="locations-used">
        <div className="locations-used-heading">Locations Used</div>
        {this.props.course_collection ? (
          <CourseCollectionNavigation {...this.props.course_collection} />
        ) : null}
      </div>
    );
  }
}
